import React, { useEffect,useState } from "react";
import {Box, CircularProgress} from "@mui/material";
import Topbar from "../../../../../../../component/TopBar";
import MainBox from "../../../../../container/MainBox";
import { Outlet} from "react-router";
import {useLocation, useParams} from "react-router-dom";
import { fetchEmployeeDetailsById } from "../../../../../../../services/employee";
import TopNavbar from "../../../../../../../component/TopNavbar";
import { useNotify } from "../../../../../../../component/NotificationProvider";
import ProfileHeader from "./ProfileHeader";

const EmployeeDetails = () => {
      const notify = useNotify();
      const [loading,setLoading]=useState(false);
      const [employeeData,setEmployeeData] = useState(null);
      const location = useLocation();
      const {employeeId} = useParams();
      const [active,setActive] = useState("overview");
      const navItems = [
        {check:"overview", link:"", value:"Overview"},
        {check:"profile", link:"profile", value:"Profile"},
        {check:"attendance", link:"attendance", value:"Attendance"},
        {check:"leave", link:"leave", value:"Leave"},
        {check:"expenses", link:"expenses", value:"Expenses"},
        {check:"timesheets", link:"timesheets", value:"Timesheets"},
        {check:"compensation", link:"compensation", value:"Compensation"},
        {check:"onboarding", link:"onboarding", value:"Onboarding"},
        {check:"career", link:"career", value:"Career"},
        {check:"goals", link:"goals", value:"Goals"},
        {check:"work-history", link:"work-history", value:"Work History"},
        {check:"self-identification", link:"self-identification", value:"Self Identification"},
      ]

      useEffect(()=>{
        const { pathname } = location;
        const match = navItems
          .filter((n) => n.check !== "overview")
          .find((n) => pathname.includes(n.check));
        setActive(match ? match.check : "overview");
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[location])
    
      const fetchEmployeeDetails = async (showLoader = true) => {
        if (showLoader) setLoading(true);
        try {
          const res = await fetchEmployeeDetailsById(employeeId);
          if(res.success){
            setEmployeeData(res.data);
          } else {
            notify.error(res?.message || "Failed to load employee details");
          }
        } catch (error) {
          notify.error(error?.message || "Failed to load employee details");
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
          fetchEmployeeDetails();
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

  return (
    <Box sx={{width:"100%"}}>
       <Topbar MainHeading="Employee" breadcrumbs={[{label:"People", href:"/app/employees"},{label:"Profile"}]}/>
       {loading && !employeeData ? (
         <Box sx={{width:"100%", display:"flex", justifyContent:"center", padding:"3.75rem 0"}}>
            <CircularProgress/>
         </Box>
       ) : (
         <>
           <ProfileHeader
             employee={employeeData}
             employeeId={employeeId}
             onChanged={() => fetchEmployeeDetails(false)}
           />
           <MainBox sx={{padding: "1.5rem 1.25rem 2rem 1.25rem"}}>
               <Box sx={{ marginBottom: "1.5rem"}}>
                    <TopNavbar active={active} navItems={navItems}/>
               </Box>
               <Outlet context={[employeeData, employeeId]}/>
           </MainBox>
         </>
       )}
    </Box>
  )
}

export default EmployeeDetails